import {
  AdminUserAddressDeleteRequest,
  AdminUserAddressListResponse,
  AdminUserAddressSaveRequest,
  AdminUserAddressSaveResponse,
  AdminUserCheckRequest,
  AdminUserCheckResponse,
  AdminUserCreateRequest,
  AdminUserCreateResponse,
  AdminUserListRequest,
  AdminUserListResponse,
  AdminUserUpdateRequest,
  AdminUserUpdateResponse
} from '@/venit/services/model/techpubs-cms';
import axios, { AxiosResponse } from 'axios';

export default class UserManagementService {
  public listUsers(request: AdminUserListRequest): Promise<AxiosResponse<AdminUserListResponse>> {
    return axios.post<AdminUserListResponse>('/api/admin/users/list', request);
  }

  public createUser(request: AdminUserCreateRequest): Promise<AxiosResponse<AdminUserCreateResponse>> {
    return axios.post<AdminUserCreateResponse>('/api/admin/users/create', request);
  }

  public updateUser(request: AdminUserUpdateRequest): Promise<AxiosResponse<AdminUserUpdateResponse>> {
    return axios.post<AdminUserUpdateResponse>('/api/admin/users/update', request);
  }

  public listRoles(): Promise<AxiosResponse<string[]>> {
    return axios.get<string[]>('/api/admin/users/list-roles');
  }

  public listUserTypeRoles(): Promise<AxiosResponse<Record<string, string[]>>> {
    return axios.get<Record<string, string[]>>('/api/admin/users/user-type-roles');
  }

  public checkUserExists(request: AdminUserCheckRequest): Promise<AxiosResponse<AdminUserCheckResponse>> {
    return axios.post<AdminUserCheckResponse>('/api/admin/users/check-exists', request);
  }

  public activateUser(userId: number): Promise<AxiosResponse<AdminUserUpdateResponse>> {
    return axios.post<AdminUserUpdateResponse>(`/api/admin/users/${userId}/activate`);
  }

  public listUserAddresses(userId: number): Promise<AxiosResponse<AdminUserAddressListResponse>> {
    return axios.post<AdminUserAddressListResponse>(`/api/admin/users/${userId}/addresses/list`);
  }

  public saveUserAddress(userId: number, request: AdminUserAddressSaveRequest): Promise<AxiosResponse<AdminUserAddressSaveResponse>> {
    return axios.post<AdminUserAddressSaveResponse>(`/api/admin/users/${userId}/addresses/save`, request);
  }

  public deleteUserAddress(request: AdminUserAddressDeleteRequest): Promise<AxiosResponse<void>> {
    return axios.post<void>(`/api/admin/users/${request.userId.id}/addresses/delete`, request);
  }

}
